import config from '../config';

const appConfig = config();
const { v2 } = appConfig.apiVersion;
const { apiPrefix } = appConfig;
const ticketsUrl = `${apiPrefix}${v2}/tickets`;

export default class PolicyHolderExclusionService {
  constructor(client) {
    this.client = client;
  }

  async create(payload) {
    const response = await this.client.post(
      `${ticketsUrl}/policy-holder-exclusions`,
      payload
    );
    return response.data;
  }

  async getTicket(ticketId) {
    const response = await this.client.get(`${ticketsUrl}/${ticketId}`);
    return response.data;
  }

  async getExclusions(ticketId) {
    const response = await this.client.get(
      `${ticketsUrl}/${ticketId}/employee-coverage-exclusions`
    );
    return response.data;
  }

  async updateExclusion(ticketId, exclusionId, payload) {
    const response = await this.client.patch(
      `${ticketsUrl}/${ticketId}/employee-coverage-exclusions/${exclusionId}`,
      payload
    );
    return response.data;
  }

  async updateExclusions(ticketId, payload) {
    const response = await this.client.patch(
      `${ticketsUrl}/${ticketId}/employee-coverage-exclusions`,
      payload
    );
    return response.data;
  }

  async patchStatus(ticketId, status) {
    const response = await this.client.patch(
      `${ticketsUrl}/${ticketId}/status`,
      {
        status
      }
    );
    return response.data;
  }
}
